module.exports = __webpack_public_path__ + "img/logo.51aa6a6c.jpeg";